import { render, staticRenderFns } from "./swpResources.vue?vue&type=template&id=8827bc8a"
import script from "./swpResources.vue?vue&type=script&lang=js"
export * from "./swpResources.vue?vue&type=script&lang=js"
import style0 from "./swpResources.vue?vue&type=style&index=0&id=8827bc8a&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8827bc8a')) {
      api.createRecord('8827bc8a', component.options)
    } else {
      api.reload('8827bc8a', component.options)
    }
    module.hot.accept("./swpResources.vue?vue&type=template&id=8827bc8a", function () {
      api.rerender('8827bc8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/swpResources.vue"
export default component.exports